<app-toast-container></app-toast-container>
<div class="page-loader" *ngIf="loaderService.isLoading | async">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">{{"Loading"|translate}}...</span>
  </div>
</div>
<!-- Client Environment Sticky Bar Start-->
<!-- <div class="page-sticky-bar" *ngIf="showClientBanner||maintenanceStartWarning||isMaintenancModeOn">
  <div [ngClass]="{'pad': (showClientBanner&&(!maintenanceStartWarning||!isMaintenancModeOn)) || (!showClientBanner&&(maintenanceStartWarning||isMaintenancModeOn)),
  'pad2':  showClientBanner&&(maintenanceStartWarning||isMaintenancModeOn)}">
    <div>
      <ng-container *ngIf="showClientBanner">
        <strong>{{"Client Environment"|translate}}: {{ clientName }}</strong>
        <button
          type="button"
          class="btn btn-sm btn-logout btn-outline-light"
          (click)="logoutClient()"
        >
        {{"Logout"|translate}}
        </button>
      </ng-container>
    </div>
    <div>
      <ng-container *ngIf="maintenanceStartWarning">
        <strong>{{"Attention: Log off for nightly maintenance scheduled for 9:00pm Pacific Time"|translate}}</strong>
      </ng-container>
      <ng-container *ngIf="isMaintenancModeOn">
        <strong>{{"Attention: Application is in Maintenance Mode. Estimated completion time is 2:00am Pacific Time"|translate}}.</strong>
      </ng-container>
    </div>
  </div>
  
</div> -->
<!-- Client Environment Sticky Bar End-->
<div class="body-wrapper" *ngIf="!isServiceUnavailable">
<!-- <div class="body-wrapper" [ngClass]="{'show-login-as-client': (showClientBanner&&(!maintenanceStartWarning||!isMaintenancModeOn)) || (!showClientBanner&&(maintenanceStartWarning||isMaintenancModeOn)),
  'show-login-as-client2':  showClientBanner&&(maintenanceStartWarning||isMaintenancModeOn)}"> -->
  <router-outlet></router-outlet>
</div>

<div *ngIf="isServiceUnavailable">
  <app-service-not-available></app-service-not-available>
</div>


